import { Children, useEffect, useState } from "react"
export default function ConfirmDialog({ title, children, show, onClose, handleDo, isBusy = false }) {

    useEffect(() => {
        if (!show)
            return;

    }, [show])

    if (!show)
        return null

    return (

        <div className="modal d-block" >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        {title}
                        <button className="btn-close" onClick={onClose} />
                    </div>

                    <div className="modal-body">
                        {children}
                    </div>

                    <div className="modal-footer">
                        <button variant="success" className="col btn btn-success btn-block  "
                            onClick={handleDo}
                            disabled={isBusy}
                        >
                            {isBusy &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                            <span>تایید </span>
                        </button>
                        <button className="col btn btn-danger  " data-bs-dismiss="modal"
                            onClick={onClose}>
                            <span>انصراف</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )

}
